import { ReactNode } from "react";
import { getGatewayScoreColorAndDesc } from "../../utils";
import clsx from "clsx";
import { PremiumSVG } from "../../../../../assets";

interface DataCardProps {
  title: string;
  subtitle?: string;
  gatewayScore?: number;
  children: ReactNode;
  premium?: boolean;
}

interface DataCardRowProps {
  title: string;
  valueElement: React.ReactElement;
}

export const DataCardRow = ({ title, valueElement }: DataCardRowProps) => {
  return (
    <div className="flex flex-col gap-1 py-3 first-of-type:pt-0 last-of-type:pb-0">
      <p className="text-sm font-normal">{title}</p>
      {valueElement}
    </div>
  );
};

export const DataCard = ({
  title,
  subtitle,
  gatewayScore,
  children,
  premium,
}: DataCardProps) => {
  const { color: gatewayScoreBgColor } =
    getGatewayScoreColorAndDesc(gatewayScore);

  return (
    <div className="flex flex-col gap-5 flex-1 bg-[#55A6FB1A] rounded-xl p-5">
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-2">
          <h3 className="font-medium flex items-center wrap">
            {title}
            {premium && (
              <span className="ml-2">
                <PremiumSVG />
              </span>
            )}
          </h3>
          {subtitle && <p className="text-xs opacity-50">{subtitle}</p>}
        </div>
        {gatewayScore && (
          <div
            className={clsx(
              "px-2 py-[6px] rounded-md font-medium",
              gatewayScoreBgColor && `bg-[${gatewayScoreBgColor}]`,
            )}
          >
            {gatewayScore}
          </div>
        )}
      </div>
      <div className="flex flex-col divide-y divide-solid divide-[#ffffff] divide-opacity-5">
        {children}
      </div>
    </div>
  );
};
